/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_1_QInputs */

const en_control_faq_1_q = /** @type {(inputs: Control_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this an official resource?`)
};

const zh_control_faq_1_q = /** @type {(inputs: Control_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTROL Resonant Tools 是官网吗？`)
};

/**
* | output |
* | --- |
* | "Is this an official resource?" |
*
* @param {Control_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_1_q = /** @type {((inputs?: Control_Faq_1_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_1_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_1_q(inputs)
	return zh_control_faq_1_q(inputs)
});
export { control_faq_1_q as "control.faq.1.q" }